import { render, staticRenderFns } from "./HomeLandingPage.vue?vue&type=template&id=615cce56&scoped=true"
import script from "./HomeLandingPage.vue?vue&type=script&lang=js"
export * from "./HomeLandingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615cce56",
  null
  
)

export default component.exports